import type { FunctionComponent } from 'react';
import { Loading } from '..';
import './styles.less';

interface Props {
  isLoading: boolean;
  isLoaded: boolean;
  children?: React.ReactNode;
}

/**
 * @deprecated Use layout-aware MUI Skeleton components instead.
 */
const PageLoader: FunctionComponent<Props> = ({ isLoaded, isLoading, children }) => {
  return !isLoaded ? (
    <div className="page-loader">
      <Loading isLoading={isLoading} />
    </div>
  ) : (
    <>{children}</>
  );
};

export default PageLoader;
